const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'span'] as const;

const removeUnsafeBlocks = (value: string): string =>
  value
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '');

const preserveAllowedTags = (value: string): string =>
  ALLOWED_TAGS.reduce((result, tag) => {
    const openTag = new RegExp(`<${tag}\\b[^>]*>`, 'gi');
    const closeTag = new RegExp(`</${tag}>`, 'gi');

    return result.replace(openTag, `[[[${tag}]]]`).replace(closeTag, `[[[/${tag}]]]`);
  }, value);

const restoreAllowedTags = (value: string): string =>
  ALLOWED_TAGS.reduce((result, tag) => {
    const openToken = new RegExp(`\\[\\[\\[${tag}\\]\\]\\]`, 'g');
    const closeToken = new RegExp(`\\[\\[\\[/${tag}\\]\\]\\]`, 'g');

    return result.replace(openToken, `<${tag}>`).replace(closeToken, `</${tag}>`);
  }, value);

export const hasHtmlMarkup = (value: string): boolean => /<[^>]+>/.test(value);

export const sanitizeCatalogHtml = (value: string): string => {
  if (!value) return '';

  const withoutBlocks = removeUnsafeBlocks(value);
  const preserved = preserveAllowedTags(withoutBlocks);
  const stripped = preserved.replace(/<[^>]*>/g, '');

  return restoreAllowedTags(stripped);
};
